import Vuex from 'vuex'
import Vue from 'vue'

import { getTables } from '@/api.js'

Vue.use(Vuex)

// setup Vue store
const store = new Vuex.Store({
    state: {
        email: "",
        planAvailable: false,
        db: "tpch",
        tables: []
    },
    mutations: {
        setPlanAvailability(state, avail) {
            state.planAvailable = avail
        },
        setDb(state, db) {
            state.db = db
            localStorage.db = db
        },
        setTables(state, tables) {
            state.tables = tables
        },
        setEmail(state, email) {
            state.email = email
            localStorage.email = email
        }
    },
    actions: {
        async setDb(context, db) {
            // fetch tables
            let response = await getTables(db)
            context.commit("setTables", response.data)
            // change db if fetch is successful
            context.commit("setDb", db)
        }
    }
})

export {
    store
}
